module.exports = __webpack_public_path__ + "static/media/campus maintenance.fde0af71.svg";